var _path, _path2, _path3, _path4, _path5, _path6, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVelvet(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 142,
    height: 37,
    viewBox: "0 0 142 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.4516 35.9039L0 0.989085H8.30833L18.5454 29.2275H15.133L25.5184 0.989085H33.7279L20.1279 35.9039H13.4516Z",
    fill: "url(#paint0_linear_953_6450)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M44.5124 36.4478C41.9078 36.4478 39.5834 35.9203 37.5393 34.8653C35.5282 33.7773 33.9456 32.2772 32.7917 30.365C31.6378 28.4527 31.0608 26.2932 31.0608 23.8864C31.0608 21.4797 31.6213 19.3366 32.7422 17.4574C33.8962 15.5451 35.4458 14.045 37.391 12.957C39.3362 11.869 41.5286 11.325 43.9684 11.325C46.3422 11.325 48.4358 11.8361 50.2491 12.8581C52.0624 13.8802 53.4801 15.2979 54.5022 17.1112C55.5572 18.9245 56.0847 21.0016 56.0847 23.3424C56.0847 23.7711 56.0517 24.2326 55.9858 24.7272C55.9528 25.1887 55.8704 25.7327 55.7385 26.3592L35.0171 26.4086V21.2159L52.524 21.1665L49.26 23.3424C49.227 21.9577 49.0127 20.8203 48.6171 19.9301C48.2215 19.007 47.628 18.3146 46.8367 17.853C46.0784 17.3585 45.1388 17.1112 44.0178 17.1112C42.8309 17.1112 41.7924 17.3914 40.9022 17.9519C40.045 18.4794 39.3691 19.2377 38.8746 20.2268C38.413 21.2159 38.1822 22.4193 38.1822 23.837C38.1822 25.2547 38.4295 26.4746 38.924 27.4966C39.4516 28.4857 40.1769 29.2605 41.1 29.821C42.0561 30.3485 43.1771 30.6122 44.4629 30.6122C45.6498 30.6122 46.7213 30.4144 47.6775 30.0188C48.6336 29.5902 49.4743 28.9638 50.1996 28.1395L54.3538 32.2937C53.1669 33.6784 51.7327 34.7169 50.0513 35.4093C48.3698 36.1017 46.5235 36.4478 44.5124 36.4478Z",
    fill: "url(#paint1_linear_953_6450)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M59.737 35.9039V0H67.3035V35.9039H59.737Z",
    fill: "url(#paint2_linear_953_6450)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M80.1983 35.9039L70.0107 11.869H78.1707L85.0943 31.898H81.5336L88.4572 11.869H96.4688L86.2812 35.8544L80.1983 35.9039Z",
    fill: "url(#paint3_linear_953_6450)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M110.435 36.4478C107.831 36.4478 105.506 35.9203 103.462 34.8653C101.451 33.7773 99.8687 32.2772 98.7147 30.365C97.5608 28.4527 96.9838 26.2932 96.9838 23.8864C96.9838 21.4797 97.5443 19.3366 98.6653 17.4574C99.8192 15.5451 101.369 14.045 103.314 12.957C105.259 11.869 107.452 11.325 109.891 11.325C112.265 11.325 114.359 11.8361 116.172 12.8581C117.985 13.8802 119.403 15.2979 120.425 17.1112C121.48 18.9245 122.008 21.0016 122.008 23.3424C122.008 23.7711 121.975 24.2326 121.909 24.7272C121.876 25.1887 121.793 25.7327 121.662 26.3592L100.94 26.4086V21.2159L118.447 21.1665L115.183 23.3424C115.15 21.9577 114.936 20.8203 114.54 19.9301C114.144 19.007 113.551 18.3146 112.76 17.853C112.001 17.3585 111.062 17.1112 109.941 17.1112C108.754 17.1112 107.715 17.3914 106.825 17.9519C105.968 18.4794 105.292 19.2377 104.798 20.2268C104.336 21.2159 104.105 22.4193 104.105 23.837C104.105 25.2547 104.353 26.4746 104.847 27.4966C105.375 28.4857 106.1 29.2605 107.023 29.821C107.979 30.3485 109.1 30.6122 110.386 30.6122C111.573 30.6122 112.644 30.4144 113.6 30.0188C114.557 29.5902 115.397 28.9638 116.123 28.1395L120.277 32.2937C119.09 33.6784 117.656 34.7169 115.974 35.4093C114.293 36.1017 112.447 36.4478 110.435 36.4478Z",
    fill: "url(#paint4_linear_953_6450)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M128.589 35.9039V1.92872H136.156V35.9039H128.589ZM123.149 18.2981V11.869H141.596V18.2981H123.149Z",
    fill: "url(#paint5_linear_953_6450)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_953_6450",
    x1: 8.36431,
    y1: 2.45447,
    x2: 147.764,
    y2: 36.6914,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C4C0C0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_953_6450",
    x1: 8.36431,
    y1: 2.45447,
    x2: 147.764,
    y2: 36.6914,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C4C0C0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_953_6450",
    x1: 8.36431,
    y1: 2.45447,
    x2: 147.764,
    y2: 36.6914,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C4C0C0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_953_6450",
    x1: 8.36431,
    y1: 2.45447,
    x2: 147.764,
    y2: 36.6914,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C4C0C0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_953_6450",
    x1: 8.36431,
    y1: 2.45447,
    x2: 147.764,
    y2: 36.6914,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C4C0C0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_953_6450",
    x1: 8.36431,
    y1: 2.45447,
    x2: 147.764,
    y2: 36.6914,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C4C0C0"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVelvet);
export default __webpack_public_path__ + "static/media/Velvet.77fe949021f847af2406d9dc4f4928c1.svg";
export { ForwardRef as ReactComponent };